import { digitsOnly } from './brIdentity';

export type ViaCepAddress = {
  street: string;
  neighborhood: string;
  city: string;
  state: string;
};

type ViaCepResponse = {
  erro?: boolean | string;
  logradouro?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
};

export async function lookupCep(cep: string): Promise<ViaCepAddress | null> {
  const digits = digitsOnly(cep);
  if (digits.length !== 8) return null;
  const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
  if (!res.ok) return null;
  const data = (await res.json()) as ViaCepResponse;
  if (data.erro === true || data.erro === 'true') return null;
  const city = String(data.localidade || '').trim();
  const state = String(data.uf || '').trim().toUpperCase();
  if (!city || state.length !== 2) return null;
  return {
    street: String(data.logradouro || '').trim(),
    neighborhood: String(data.bairro || '').trim(),
    city,
    state,
  };
}
